import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Helmet } from "react-helmet-async";
import { Palette, Camera, Box, Tag, Layers, Sparkles } from "lucide-react";

const subServices = ["Graphic Design", "Product Shots", "3D Design", "Label & Packaging"];

const features = [
  {
    icon: Palette,
    title: "Graphic Design",
    description: "Brand identity, logos, social media graphics, marketing materials, and visual content that tells your story.",
  },
  {
    icon: Camera,
    title: "Product Shots",
    description: "Professional product photography that showcases your items beautifully for e-commerce and marketing.",
  },
  {
    icon: Layers,
    title: "3D Design",
    description: "Stunning 3D renders, product visualizations, and mockups that bring your ideas to life.",
  },
  {
    icon: Tag,
    title: "Label Design",
    description: "Eye-catching labels that communicate your brand and stand out on shelves.",
  },
  {
    icon: Box,
    title: "Packaging Design",
    description: "Custom packaging that creates an unforgettable unboxing experience for your customers.",
  },
  {
    icon: Sparkles,
    title: "Brand Collateral",
    description: "Business cards, brochures, flyers, and all the print materials your brand needs.",
  },
];

const benefits = [
  {
    title: "Cohesive Brand Identity",
    description: "All design elements work together to create a unified, memorable brand presence.",
  },
  {
    title: "Print & Digital Ready",
    description: "Designs optimized for both online platforms and physical print materials.",
  },
  {
    title: "Unlimited Revisions",
    description: "We work with you until every design is exactly what you envisioned.",
  },
  {
    title: "Fast Turnaround",
    description: "Quick delivery without compromising on quality. Meet your deadlines every time.",
  },
];

const process = [
  {
    title: "Discovery",
    description: "Understanding your brand, target audience, and design requirements.",
  },
  {
    title: "Concept",
    description: "Creating multiple design concepts for your review and feedback.",
  },
  {
    title: "Refinement",
    description: "Perfecting the chosen concept with revisions until it's just right.",
  },
  {
    title: "Delivery",
    description: "Final files in all formats you need, ready for print and digital use.",
  },
];

export default function Design() {
  return (
    <>
      <Helmet>
        <title>Graphic Design Services | Logos, Branding & Marketing Materials | Barton</title>
        <meta name="description" content="Professional graphic design services for small businesses. We create stunning logos, brand identities, business cards, and marketing materials that make your business stand out." />
        <meta property="og:title" content="Graphic Design Services | Barton" />
        <meta property="og:description" content="Professional graphic design for small businesses. Logos, branding, business cards, and marketing materials." />
        <meta property="og:url" content="https://barton.uk/services/design" />
        <meta property="og:image" content="https://barton.uk/og-image.png" />
        <meta name="twitter:title" content="Graphic Design Services | Barton" />
        <meta name="twitter:description" content="Professional graphic design for small businesses. Logos, branding, and marketing materials." />
        <meta name="twitter:image" content="https://barton.uk/og-image.png" />
      </Helmet>
      <ServicePageTemplate
        title="Design"
        subtitle="Visual Excellence for Your Brand"
        description="From graphic design to 3D renders, product photography to packaging - we create stunning visuals that make your brand unforgettable."
        image="https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&q=80"
        icon={Palette}
        features={features}
        benefits={benefits}
        process={process}
        subServices={subServices}
        ctaText="Get In Touch"
        accentColor="pink"
      />
    </>
  );
}
